
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Launched a new website for our `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io"
      }}>{`Component Libraries`}</a>{`, new React components for `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-drawer--get-read-me-story"
      }}>{`Drawer`}</a>{`, `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-list-item-tag--get-read-me-story"
      }}>{`ListItemTag`}</a>{`, `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-spacer--get-read-me-story"
      }}>{`Spacer`}</a>{`, and
`}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-user-menu--get-read-me-story"
      }}>{`UserMenu`}</a>{`, and updated pxblue.github.io with a new look and new content for designers.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;